var app = angular.module('app', ['ngRoute', 'ngSanitize', 'pascalprecht.translate']);

app.config(['$routeProvider', '$locationProvider', '$httpProvider', '$translateProvider',
  function ($routeProvider, $locationProvider, $httpProvider, $translateProvider) {
      $httpProvider.defaults.timeout = 5000;
      $locationProvider.html5Mode(false);

      $routeProvider.
		when('/', {
		    templateUrl: '../frontend/onlinebooking/src/partials/index.html',
		    controller: 'MainController'
		}).
		when('/register-birthday', {
		    templateUrl: '../frontend/onlinebooking/src/partials/register-birthday.html',
		    controller: 'RegisterController'
		}).
		when('/register-visits', {
		    templateUrl: '../frontend/onlinebooking/src/partials/register-visits.html',
		    controller: 'RegisterController'
		}).
		when('/visits', {
		    templateUrl: '../frontend/onlinebooking/src/partials/visits.html',
		    controller: 'AllVisitController'
		}).
		when('/select-visit-date/:id', {
		    templateUrl: '../frontend/onlinebooking/src/partials/select-visit-date.html',
		    controller: 'VisitsController'
		}).
		when('/booked/:show', {
		    templateUrl: '../frontend/onlinebooking/src/partials/booked.html',
		    controller: 'VisitsController'
		}).
		when('/select-package', {
		    templateUrl: '../frontend/onlinebooking/src/partials/packages.html',
		    controller: 'PackagesController'
		}).
		when('/select-date/:id', {
		    templateUrl: '../frontend/onlinebooking/src/partials/select-date.html',
		    controller: 'CalendarController'
		}).
		when('/select-add-ons/:id', {
		    templateUrl: '../frontend/onlinebooking/src/partials/select-addons.html',
		    controller: 'AddonsController'
		}).
		when('/select-add-ons-visits/:id', {
		    templateUrl: '../frontend/onlinebooking/src/partials/select-addons-visits.html',
		    controller: 'AddonsControllerVisits'
		}).
		when('/final', {
		    templateUrl: '../frontend/onlinebooking/src/partials/final.html',
		    controller: 'FinalController'
		}).
		when('/finish', {
		    templateUrl: '../frontend/onlinebooking/src/partials/finish.html',
		    controller: 'FinishController'
		}).
		when('/complete-booking', {
		    templateUrl: '../frontend/onlinebooking/src/partials/complete-booking.html',
		    controller: 'FinalController'
		}).
		when('/booking-completed', {
		    templateUrl: '../frontend/onlinebooking/src/partials/complete-booking.html',
		    controller: 'FinishController'
		}).
		when('/complete-booking/:OrderID/:tpwot', {
		    templateUrl: '../frontend/onlinebooking/src/partials/complete-booking.html',
		    controller: 'CompleteController'
		}).
		otherwise({
		    redirectTo: '/'
		});


      //$translateProvider.translations('en', dictEN)
      //                .translations('bg', dictBG);

      //$translateProvider.preferredLanguage('bg');

      $translateProvider.fallbackLanguage('en');
      $translateProvider.registerAvailableLanguageKeys(['bg', 'en', 'pl', 'es', 'esc', 'pt', 'esm', 'it', 'ro', 'lt', 'id', 'de'], {
          'bg_*': 'bg',
          'en_*': 'en',
          'pl_*': 'pl',
		  'pt_*': 'pt',
          'es_*': 'es',
          'esc_*': 'esc',
		  'esm_*': 'esm',
		  'it_*': 'it',
		  'ro_*': 'ro',
		  'lt_*': 'lt',
		  'id_*': 'id',
		  'de_*': 'de'
      });

      var ob_bg;
      var ob_en;
      var ob_pl;
	  var ob_pt;
      var ob_es;
      var ob_esc;
	  var ob_esm;
	  var ob_it;
	  var ob_ro;
	  var ob_lt;
	  var ob_id;
	  var ob_de;

      $.ajax({
          async: false,
          url: "../frontend/onlinebooking/src/translate/bg.json",
          success: function (json) {
              ob_bg = json;
          }
      });

      $.ajax({
          async: false,
          url: "../frontend/onlinebooking/src/translate/en.json",
          success: function (json) {
              ob_en = json;
          }
      });

      $.ajax({
          async: false,
          url: "../frontend/onlinebooking/src/translate/pl.json",
          success: function (json) {
              ob_pl = json;
          }
      });

	  $.ajax({
		async: false,
		url: "../frontend/onlinebooking/src/translate/pt.json",
		success: function (json) {
			ob_pt = json;
		}
	});

      $.ajax({
          async: false,
          url: "../frontend/onlinebooking/src/translate/es.json",
          success: function (json) {
              ob_es = json;
          }
      });

      $.ajax({
          async: false,
          url: "../frontend/onlinebooking/src/translate/es-ca.json",
          success: function (json) {
              ob_esc = json;
          }
      });

	  $.ajax({
		async: false,
		url: "../frontend/onlinebooking/src/translate/es-mx.json",
		success: function (json) {
			ob_esm = json;
		}
	});

	$.ajax({
		async: false,
		url: "../frontend/onlinebooking/src/translate/it.json",
		success: function (json) {
			ob_it = json;
		}
	});

	$.ajax({
		async: false,
		url: "../frontend/onlinebooking/src/translate/ro.json",
		success: function (json) {
			ob_ro = json;
		}
	});

	$.ajax({
		async: false,
		url: "../frontend/onlinebooking/src/translate/lt.json",
		success: function (json) {
			ob_lt = json;
		}
	});

	$.ajax({
		async: false,
		url: "../frontend/onlinebooking/src/translate/id.json",
		success: function (json) {
			ob_id = json;
		}
	});

	$.ajax({
		async: false,
		url: "../frontend/onlinebooking/src/translate/de.json",
		success: function (json) {
			ob_de = json;
		}
	});

      $translateProvider.translations('en', ob_en);
      $translateProvider.translations('bg', ob_bg);
      $translateProvider.translations('pl', ob_pl);
	  $translateProvider.translations('pt', ob_pt);
      $translateProvider.translations('es', ob_es);
      $translateProvider.translations('esc', ob_esc);
	  $translateProvider.translations('esm', ob_esm);
	  $translateProvider.translations('it', ob_it);
	  $translateProvider.translations('ro', ob_ro);
	  $translateProvider.translations('lt', ob_lt);
	  $translateProvider.translations('id', ob_id);
	  $translateProvider.translations('de', ob_de);

}]);